import {
  FacebookOutlined,
  InstagramOutlined,
  LaptopOutlined,
  TwitterOutlined,
  YoutubeOutlined,
} from '@ant-design/icons';
import { OrganizationDetail } from '@omniafishing/core';
import React from 'react';
import styles from './org_info_list.less';

export const OrgInfoList = ({ organization }: { organization: OrganizationDetail }) => {
  const { instagram, facebook, youtube, twitter, website, state, street, city, zip_code } =
    organization;
  const hasSocial = instagram || facebook || youtube || twitter || website;
  return (
    <>
      {hasSocial && (
        <ul className={styles.socials}>
          {instagram && (
            <li className={styles.social}>
              <a
                href={`https://www.instagram.com/${instagram}`}
                rel="nofollow"
                className={styles.socialLink}
              >
                <InstagramOutlined />
              </a>
            </li>
          )}
          {facebook && (
            <li className={styles.social}>
              <a
                href={`https://www.facebook.com/${facebook}`}
                rel="nofollow"
                className={styles.socialLink}
              >
                <FacebookOutlined />
              </a>
            </li>
          )}
          {youtube && (
            <li className={styles.social}>
              <a href={youtube} rel="nofollow" className={styles.socialLink}>
                <YoutubeOutlined />
              </a>
            </li>
          )}
          {twitter && (
            <li className={styles.social}>
              <a
                href={`https://twitter.com/${twitter}`}
                rel="nofollow"
                className={styles.socialLink}
              >
                <TwitterOutlined />
              </a>
            </li>
          )}
          {website && (
            <li className={styles.social}>
              <a href={website} rel="nofollow" className={styles.socialLink}>
                <LaptopOutlined />
              </a>
            </li>
          )}
        </ul>
      )}
      <p>
        {street && (
          <>
            {street}
            <br />
          </>
        )}
        {city && (
          <>
            {city}
            <br />
          </>
        )}
        {state && <>{state},</>}
        {zip_code && zip_code}
      </p>
    </>
  );
};
